/** Instance administration lives outside any project, at `/admin` (issue #346). */
export const ADMIN_BASE = '/admin';
/** Breadcrumb shown by the admin pages' headers in place of a project name. */
export const ADMIN_BREADCRUMB = 'Administration';
